import wsClient from "@/plugins/ws/client"

export default new class SocketRegister {
    handle(fn) {
        wsClient.addMessageHandler(fn)
    }
}
